var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowOutgoingIcon = function SvgArrowOutgoingIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#30A0C4",
    fillRule: "evenodd",
    d: "M10.394 1.56V6.96c0 .314-.257.56-.584.56-.327 0-.583-.246-.583-.56V2.904L2.016 9.827c-.117.112-.256.156-.42.156-.163 0-.304-.044-.421-.156-.233-.224-.233-.582 0-.784L8.41 2.12H4.187c-.327 0-.584-.246-.584-.56 0-.314.257-.56.584-.56H9.81c.327 0 .584.246.584.56z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowOutgoingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-outgoing-icon.67cd0c431aadbbfe4187313ef2c96809.svg";